export * from './conferences.tags';
export var ConferenceLogType;
(function (ConferenceLogType) {
    ConferenceLogType[ConferenceLogType["ParticipantJoined"] = 1] = "ParticipantJoined";
    ConferenceLogType[ConferenceLogType["ParticipantLeft"] = 2] = "ParticipantLeft";
    ConferenceLogType[ConferenceLogType["Error"] = 3] = "Error";
    ConferenceLogType[ConferenceLogType["Info"] = 4] = "Info";
})(ConferenceLogType || (ConferenceLogType = {}));
